export default "__VITE_ASSET__9d5d44ce__"